export const graphConfig = {
  rangeSelector: {
    selected: 5,
    buttons: [
      {
        type: 'month',
        count: 1,
        text: '1m',
      },
      {
        type: 'month',
        count: 3,
        text: '3m',
      },
      {
        type: 'month',
        count: 6,
        text: '6m',
      },
      {
        type: 'ytd',
        text: 'YTD',
      },
      {
        type: 'year',
        count: 1,
        text: '1y',
      },
      {
        type: 'year',
        count: 3,
        text: '3y',
      },
      {
        type: 'year',
        count: 5,
        text: '5y',
      },
      {
        type: 'all',
        text: 'All',
      },
    ],
  },
  yAxis: {
    labels: {
      formatter() {
        return (this.value > 0 ? ' + ' : '') + this.value + '%';
      },
    },
    plotLines: [
      {
        value: 0,
        width: 2,
        color: 'silver',
      },
    ],
  },

  legend: {
    align: 'left',
    verticalAlign: 'bottom',
    borderWidth: 0,
    enabled: true,
    itemStyle: {
      color: '#666',
    },
  },

  plotOptions: {
    series: {
      compare: 'percent',
    },
  },

  tooltip: {
    pointFormat:
      '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)<br/>',
    valueDecimals: 2,
    split: true,
  },
};



// WEBPACK FOOTER //
// ./constants/graphConfig.ts